<template>
  <div>
    <span><img src="/images/agence.jpg" alt="Notre agence" style="max-width: 100%;"/></span>
    <div class="flex column items-center center container">
      <div class="red_border pt3" v-html="$store.state.translations.texte_agence"></div>
    </div>
    <!-- Section white banner -->
    <div class="background_white pb4">
      <h2 class="caps black italic center mt3 pt3 pb1 smaller">{{$store.state.translations.nos_expertises_metiers}}</h2>
      <div class="flex flex-wrap px3 container">
        <router-link :to="{name: 'article', params: {id: article.slug}}" class="block_expertise col-12 sm-col-6 md-col-4" :class="{visible: article.isVisible}" v-for="(article, i) in $store.state.articles" :key="i" v-observe-visibility="{callback: visible => {if (visible){$set(article, 'isVisible', true)}}, once: true}">
          <div class="caps bold font2">
            {{article.acf.mot1}}
            <div class="caps bold relative" style="top: -23px; opacity: 0.5; font-size: 140%; line-height: 0.7;" :style="{color: article.acf.couleur}">
              {{article.acf.mot2}}
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <!-- Black banner -->
    <div class="container mb4">
      <h2 class="caps black italic center mt2 pt3 pb1 smaller white">{{$store.state.translations.mais_pas_que}}</h2>
      <div class="flex wrap book inputs white caps">
        <span class="col-12 sm-col-6 md-col-4" :key="i" v-for="(expertise, i) in ($store.state.translations.autres_expertises ? $store.state.translations.autres_expertises.split('\n') : [])">{{expertise}}</span>
      </div>
    </div>
    <!-- brands banner -->
    <brands/>
  </div>
</template>
<script>
import Brands from "../components/brands";
export default {
  components: {Brands},
};
</script>